// extracted by mini-css-extract-plugin
module.exports = {"product-card":"cards_product-card__oqV_5","cards":"cards_cards__CbXob","card_container":"cards_card_container__eZ5My"};